import { Icon, IconProps } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '~/lib';
import Tooltip from '~/components/Tooltip';
import { ValuationStatsTypeResponseType } from '~/types/valuationTypes';

export default function ValuationStats({
  statsData,
}: {
  statsData: ValuationStatsTypeResponseType | undefined;
}) {
  const { t } = useTranslation('app');

  if (statsData) {
    const statsUi: {
      id: number;
      title: string;
      value: number;
      icon: IconProps['name'];
      iconBoxClassName: string;
      tooltipText?: string;
      tooltipId?: string;
      isPrice?: boolean;
    }[] = [
      {
        id: 1,
        title: t('numberOfProperties'),
        value: statsData?.count,
        icon: 'listing' as IconProps['name'],
        iconBoxClassName: 'bg-[#75B4DB59] text-blue_dark_1',
      },
      {
        id: 2,
        title: t('purchasePrice'),
        value: statsData?.purchasePrice,
        icon: 'bar-chart' as IconProps['name'],
        iconBoxClassName: 'bg-[#C9C6C573] text-gray__dark_2',
        tooltipText: t('valuationPriceDescription'),
        tooltipId: 'tooltip-purchasePrice',
        isPrice: true,
      },
      {
        id: 3,
        title: t('valuationPrice'),
        value: statsData?.valuationPrice,
        icon: 'folder' as IconProps['name'],
        iconBoxClassName: 'bg-[#00841824] text-green_dark',
        tooltipText: t('purchasePriceDescription'),
        tooltipId: 'tooltip-valuationPrice',
        isPrice: true,
      },
    ];

    return (
      <div className="grid gap-2x md:grid-cols-3 md:gap-3x">
        {statsUi.map((ui) => {
          return (
            <div
              className="flex items-center gap-3x rounded-[12px] p-3x bg-gray_light_1"
              key={`state-${ui.id}`}
            >
              <div
                className={`flex h-[56px] w-[56px] items-center justify-center rounded-[12px]  ${ui.iconBoxClassName}`}
              >
                <Icon name={ui.icon} size="40px" />
              </div>
              <div className="flex flex-col gap-0.5x">
                <div className="flex gap-x items-center">
                  <p className="text-body_2 text-gray__dark_2">{ui.title}</p>
                  {ui.tooltipText && ui.tooltipId && (
                    <Tooltip
                      id={ui.tooltipId}
                      text={ui.tooltipText}
                      className="max-w-[272px]"
                    >
                      <Icon
                        name="info"
                        size="16px"
                        className="text-blue_dark_1"
                      />
                    </Tooltip>
                  )}
                </div>
                <p className="text-title_4 font-bold text-black">
                  {formatNumber(ui.value)}
                  {ui.isPrice && <span className="text-link"> {t('egp')}</span>}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  return null;
}
